<template>
  <header class="mb-3">
    <div class="media">
      <div class="media-left h3 mr-2">
        {{ dayLabel }}
      </div>
      <div class="media-body">
        <hr class="mt-2 mb-0 py-0 mr-0 mr-md-4">
        <small class="text-uppercase text-muted">
          {{ dateLabel }}
        </small>
      </div>
    </div>
  </header>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    date: {
      type: [String, Date],
      required: true
    }
  },
  computed: {
    dayLabel () {
      return moment(this.date).format('D')
    },
    dateLabel () {
      let d = moment(this.date)
      let today = moment()
      let tomorrow = moment().add(1, 'days')
      if (d.isSame(today, 'day')) {
        return 'Today'
      } else if (d.isSame(tomorrow, 'day')) {
        return 'Tomorrow'
      } else if (d.isSame(today, 'year')) {
        return d.format('MMMM')
      } else {
        return d.format('MMMM YYYY')
      }
    },
  }
}
</script>